import Layout from "antd/lib/layout/layout";
import styled from "styled-components";

export const BlockAdminViewWrapper = styled(Layout)`
	height: 100%;
`;
